"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crunch = void 0;
require("../JSON");
const JSON_1 = require("../JSON");
const utils_1 = require("../utils");
function flatten(data, set) {
  const recurse = data => flatten(data, set);
  const flattened = (0, JSON_1.isContainer)(data) ? (0, JSON_1.map)(data, recurse) : data;
  return set.add(flattened);
}
function crunch(data) {
  const set = (0, utils_1.CountedOrderedSet)();
  flatten(data, set);
  return set.values;
}
exports.crunch = crunch;